import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"

const AllOrders: React.SFC = () => {
    return ( 
        <OrdersLayout/>
     );
}
 
export default AllOrders;